import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid2 as Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { BookingStore } from '../../utils/stores/BookingStore';
import { ProductsStore } from '../../utils/stores/ProductsStore';
import { SummaryContent } from './BookingFormSummary';

const summaryAccordionSx = {
    container: {
        padding: { xs: '10px 10px 5px', sm: '32px 32px 5px' },
    },
    paper: {
        padding: { xs: '0 5px 8px', sm: '20px 20px 8px' },
        borderRadius: '10px',
        '& .MuiAccordionSummary-root': {
            '@media (max-width:599.95px)': {
                padding: '5px 10px',
            },
        },
        '& .MuiAccordionDetails-root': {
            '@media (max-width:599.95px)': {
                padding: '0 10px',
            },
        },
        '& .MuiAccordionSummary-content': {
            '@media (max-width:599.95px)': {
                marginBottom: '4px',
            },
        },
    },
    divider: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#D9DBE9',
        width: '100%',
        height: 0,
    },
    itemText: {
        fontSize: { xs: 15, sm: 18 },
        lineHeight: '110%',
        color: '#646673',
        mb: { xs: '15px', sm: '20px' },
        fontWeight: 300,
    },
    subtitle: {
        mb: { xs: 0, sm: '12px' },
        fontSize: { xs: 15, sm: 16 },
    },
} as const;

export default function BookingFormSummaryAccordion() {
    const productController = useContext(ProductsStore);
    const bookingController = useContext(BookingStore);

    return (
        <Box sx={summaryAccordionSx.container}>
            <Accordion sx={summaryAccordionSx.paper} style={{ maxHeight: 760, overflowY: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="booking summary accordion"
                    id="summary panel"
                >
                    <Grid container>
                        <Grid size={{ xs: 12 }}>
                            <Typography
                                variant="h6"
                                style={{ fontWeight: 400, fontSize: 24, lineHeight: '115%', paddingBottom: 10 }}
                            >
                                {productController.product.name}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Typography sx={[summaryAccordionSx.itemText, summaryAccordionSx.subtitle]}>
                                {productController.product.tagline}
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <SummaryContent />
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
